/* Napuplant — lógica de la garantía Care+ en el carrito.

   Ver snippets/napu-care-toggle.liquid para el contexto. Resumen: el producto
   'napuplant-care-garantia' tiene 250 variantes de 0,05 € a 12,50 €, de cinco en
   cinco céntimos. Se calcula el 7% del carrito SIN contar la propia garantía, se
   redondea al tramo MÁS CERCANO y se añade esa variante como línea.

   OJO al leer las variantes en el admin de Shopify: por POSICIÓN aparecen primero
   las de 0,25 en 0,25 (son las originales) y después, intercaladas, las de 0,05.
   Parece una escalera de 0,25 y no lo es. Aquí se ordenan por precio antes de
   usarlas, así que el orden del admin da igual.

   El bucle infinito es el riesgo principal: si la base incluyera la línea de
   Care+, añadirla subiría el total, lo que subiría el 7%, lo que cambiaría el
   tramo. Por eso baseCents() la descuenta siempre. */
(function () {
  var HANDLE = 'napuplant-care-garantia';
  var PERCENT = 0.07;
  var STEP = 5; // céntimos: tramos de 0,05 €

  /* Puede haber MÁS DE UN interruptor en la misma página: el del cajón lateral
     (que se renderiza en todas las páginas) y el de la página del carrito. Hay que
     tratarlos todos como uno solo, o al pulsar en uno el otro se queda desfasado. */
  var inputs = [], prices = [], spinners = [], tiers = [];
  var busy = false, queued = false;
  function anyChecked() { return inputs.some(function (i) { return i.checked; }); }

  /* El importe NO se formatea aquí: cada tramo llega ya formateado desde Liquid
     en su campo 'label', con el filtro money de Shopify (ver napu-care-toggle).

     Esta función formateaba a mano y producía "1,90 €", mientras el resto del
     carrito mostraba "€26,99", y el símbolo cambiaba de lado dentro de la misma
     pantalla. Se deja solo como red de seguridad por si un tramo llegara sin
     label. Desde el 27-sep-2026 usa window.napuDinero (theme.liquid), que lee
     el formato de la tienda, en vez de copiarlo a mano. */
  function euros(cents) {
    if (window.napuDinero) return window.napuDinero(cents);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Tipos de producto a los que SÍ se aplica la garantía de adaptación.
     Decisión de Alessandro (29-ago-2026): solo plantas. Quedan fuera los ramos
     —son producto perecedero y no se adaptan—, las macetas y Paga y señal.

     ⚠️ ESTA LISTA ESTÁ DUPLICADA en sections/napu-product.liquid, donde decide si
     la ficha muestra el bloque de Care+ en el acordeón. Tienen que decir LO MISMO:
     si la ficha lo anuncia y aquí no está cubierto, el cliente lee que puede
     contratar la garantía y luego el interruptor no le aparece en el carrito.
     No se puede compartir una sola definición, porque este archivo necesita la
     lista aunque el interruptor no se haya renderizado. Si cambias una, cambia la
     otra. */
  var TIPOS_CUBIERTOS = ['planta', 'planta interior', 'planta exterior'];

  function cubierto(item) {
    var t = (item.product_type || '').toLowerCase().trim();
    return TIPOS_CUBIERTOS.indexOf(t) !== -1;
  }

  /* Base del 7%: solo los productos cubiertos. Excluye por tanto la propia línea
     de Care+ (su tipo es 'Garantia') y todo lo que no sea planta. */
  function baseCents(cart) {
    var total = 0;
    (cart.items || []).forEach(function (it) {
      if (cubierto(it)) total += it.line_price;
    });
    return Math.max(0, total);
  }

  /* ¿Hay algo en la cesta a lo que aplicar la garantía? */
  function hayCubiertos(cart) {
    return (cart.items || []).some(cubierto);
  }

  /* Tramo correspondiente al 7%, redondeando al MÁS CERCANO (no al alza).
     Alexis pidió un 7% constante: redondear siempre hacia arriba, como hacía la
     app de Insureful, cobraba de más de forma sistemática. Con tramos de 0,05 €
     la desviación máxima es de 2,5 céntimos y se compensa en ambos sentidos. */
  function pickTier(cents) {
    if (!tiers.length) return null;
    var target = Math.round((cents * PERCENT) / STEP) * STEP;
    if (target < tiers[0].price) target = tiers[0].price;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].price >= target) return tiers[i];
    }
    return tiers[tiers.length - 1];
  }

  function currentCareLine(cart) {
    var found = null;
    (cart.items || []).forEach(function (it) {
      if (it.handle === HANDLE) found = it;
    });
    return found;
  }

  function setBusy(state) {
    busy = state;
    spinners.forEach(function (s) { s.hidden = !state; });
    inputs.forEach(function (i) { i.disabled = state; });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addVariant(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json(); });
  }

  /* Deja el carrito coherente con el estado del interruptor.
     `changed` marca si de verdad se ha tocado el carrito: hace falta para saber si
     hay que recargar la página del carrito (ver más abajo). */
  function reconcile(wanted) {
    /* Mientras napu-cart-qty aplica un lote, la garantía la ajusta él dentro de
       la misma petición. Si aquí se lanzaran escrituras en paralelo tendríamos
       otra vez dos sistemas tocando el carrito a la vez, que es justo el
       problema que se estaba resolviendo. */
    if (window.napuCare && window.napuCare.pausado) return Promise.resolve();
    if (busy) { queued = true; return Promise.resolve(); }
    setBusy(true);
    var changed = false;

    return getCart().then(function (cart) {
      var line = currentCareLine(cart);

      /* Sin productos cubiertos en el carrito (por ejemplo, solo ramos o solo
         macetas) la garantía se retira sola: no habría nada que garantizar. */
      if (!wanted || !hayCubiertos(cart)) {
        if (line) { changed = true; return changeLine(line.key, 0); }
        return null;
      }

      var tier = pickTier(baseCents(cart));
      if (!tier) return null;

      if (line && line.id === tier.id && line.quantity === 1) return null;   // ya correcto
      changed = true;
      if (line) {
        return changeLine(line.key, 0).then(function () { return addVariant(tier.id); });
      }
      return addVariant(tier.id);
    })
    .catch(function () { /* si algo falla, se deja el carrito como estaba */ })
    .then(function () {
      setBusy(false);
      if (queued) { queued = false; return reconcile(anyChecked()); }

      /* En la PÁGINA del carrito hay que recargar si se ha tocado algo.
         Cambiar de tramo implica borrar la línea y añadir otra, y eso genera una
         clave de línea nueva. La página /cart se renderiza en el servidor con las
         claves antiguas, así que sus botones de papelera apuntarían a una línea
         que ya no existe y Shopify responde 500 'parámetro lineal no válido'.
         En el cajón lateral no hace falta: se repinta solo. */
      if (changed && document.body.classList.contains('template-cart')) {
        window.location.reload();
        return;
      }
      return refreshPrice();
    });
  }

  /* Actualiza el importe mostrado y oculta el interruptor cuando no hay nada que
     garantizar: con solo ramos en la cesta, ofrecer Care+ sería vender un servicio
     que después no se podría aplicar. */
  function refreshPrice() {
    if (!prices.length) return;
    return getCart().then(function (cart) {
      var aplica = hayCubiertos(cart);
      document.querySelectorAll('[data-napu-care]').forEach(function (b) {
        b.hidden = !aplica;
      });
      if (!aplica) return;
      var tier = pickTier(baseCents(cart));
      var txt = tier ? '(' + (tier.label || euros(tier.price)) + ')' : '';
      prices.forEach(function (p) { p.textContent = txt; });
    }).catch(function () {});
  }

  function bind() {
    var boxes = document.querySelectorAll('[data-napu-care]');
    if (!boxes.length) return;

    inputs = []; prices = []; spinners = [];
    Array.prototype.forEach.call(boxes, function (box) {
      var i = box.querySelector('[data-napu-care-input]');
      var p = box.querySelector('[data-napu-care-price]');
      var s = box.querySelector('[data-napu-care-spinner]');
      if (i) inputs.push(i);
      if (p) prices.push(p);
      if (s) spinners.push(s);
    });

    var script = document.querySelector('[data-napu-care-tiers]');
    if (script) {
      try { tiers = JSON.parse(script.textContent) || []; } catch (e) { tiers = []; }
      tiers.sort(function (a, b) { return a.price - b.price; });
    }

    inputs.forEach(function (input) {
      if (input.__napuBound) return;
      input.__napuBound = true;
      input.addEventListener('change', function () {
        /* Los demás interruptores siguen al que se ha pulsado. */
        inputs.forEach(function (o) { if (o !== input) o.checked = input.checked; });
        reconcile(input.checked);
      });
    });

    /* Al enlazar hay que CUADRAR, no solo refrescar el importe mostrado.
       El interruptor solo existe dentro del cajón del carrito: si el cliente añade
       plantas con el cajón cerrado, este código no está en la página y el tramo se
       queda viejo. Al abrirlo, Liquid pinta el interruptor activado pero la línea
       sigue con el importe anterior. Por eso aquí se recalcula.

       PERO NO SE PUEDE RESUCITAR LA GARANTÍA. Aquí había un `if (anyChecked())
       reconcile(true)` a secas, y provocaba esto: al borrar la línea de Care+ con
       la papelera de la propia línea, la línea se iba, llegaba el repintado, este
       código veía el interruptor todavía marcado y la volvía a añadir. Desaparecía
       y reaparecía sin apagarse nunca (reportado por Alessandro el 1-sep-2026).

       La causa de fondo es que el interruptor vive en .minicart-total-wrapper, o
       sea FUERA de [data-cart-total-prices], y napu-cart-sync no lo repinta: su
       estado marcado se queda obsoleto en cuanto la línea desaparece por otra vía.

       Así que el carrito manda sobre el interruptor, y no al revés:
       - La línea sigue en el carrito  → cuadrar el tramo, como siempre.
       - La línea ya no está           → la ha quitado el cliente. Se apaga el
                                         interruptor. NO se vuelve a añadir.

       Que el interruptor esté marcado siempre significa que la línea estaba en el
       carrito cuando Liquid lo pintó, así que si ahora no está solo puede ser
       porque alguien la ha quitado. Y un servicio de pago no puede volver solo. */
    if (!anyChecked()) { refreshPrice(); return; }

    getCart().then(function (cart) {
      if (currentCareLine(cart)) {
        reconcile(true);
        return;
      }
      inputs.forEach(function (i) { i.checked = false; });
      document.querySelectorAll('[data-napu-care]').forEach(function (b) {
        b.setAttribute('data-active', 'false');
      });
      refreshPrice();
    }).catch(function () { /* sin red se deja como está: el siguiente repintado lo cuadra */ });
  }

  /* El tema repinta #minicart entero al abrir el cajón, sin avisar con ningún
     evento. Se observa ese contenedor para volver a enlazar y cuadrar el tramo.

     OJO: aquí NO se puede usar subtree. Con subtree, refrescar el importe del
     interruptor cambia un nodo de texto dentro de #minicart, eso cuenta como
     mutación, dispara este observer, que vuelve a refrescar el importe... y se
     queda girando el indicador de carga para siempre. Sin subtree solo salta
     cuando el tema sustituye los hijos directos, que es justo lo que hace al
     abrir el cajón. */
  function watchDrawer() {
    var host = document.getElementById('minicart');
    if (!host || host.__napuWatched) return;
    host.__napuWatched = true;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(bind, 120);
    }).observe(host, { childList: true });
  }

  document.addEventListener('DOMContentLoaded', function () { bind(); watchDrawer(); });
  document.addEventListener('napu:cart-synced', function () { bind(); watchDrawer(); });
  window.napuCareBind = bind;

  /* ---------------------------------------------------------------------------
     API para napu-cart-qty.js

     El control de cantidades del cajón necesita saber QUÉ TRAMO de Care+ tocará
     tras un cambio de cantidades, y necesita saberlo ANTES de enviar nada, para
     mandar el ajuste de la garantía en el mismo lote que las plantas.

     Se expone el cálculo en vez de copiarlo. Este archivo ya arrastra una
     duplicación conocida (la lista de tipos cubiertos está también en
     napu-product.liquid, con su aviso correspondiente); una tercera copia del
     porcentaje, los tramos y el redondeo era pedir que se separaran.

     `pausado` lo levanta napu-cart-qty mientras aplica su lote: en ese rato es
     él quien se encarga de dejar la garantía en su sitio, y este módulo no debe
     lanzar sus propias escrituras por encima.
     --------------------------------------------------------------------------- */
  window.napuCare = {
    HANDLE: HANDLE,
    pausado: false,
    cubierto: cubierto,
    /* Tramo que corresponde a una base en céntimos, o null si no hay tramos.
       `tiers` se rellena en bind(), así que si el interruptor aún no se ha
       pintado esto devuelve null y quien llame debe no tocar la garantía. */
    tramoPara: function (baseCents) { return pickTier(baseCents); },
    hayTramos: function () { return tiers.length > 0; },
    /* Repinta el importe del interruptor sin tocar el carrito. */
    refrescarImporte: refreshPrice
  };
})();
